import { Link } from "react-router-dom";
import React from "react";
import { Helmet } from "react-helmet";
import { LazyLoadImage } from "react-lazy-load-image-component";


const TajBusinessConnect = () => {
  return (
      <>


    <div>
     

      {/* Main Section */}
      <div className="container mt-5">
        <div className="row align-items-center">
          <div className="taj-bussiness-main">
          <div className="col-md-6   col-12">
            <LazyLoadImage
              src= "/images/corpo/corporate-sub_.jpg"
              alt="V Hotel The Grnad Shoba about-image"  loading="lazy" title="A WORLD OF PRIVILEGES AND BENEFITS V Hotel The Grnad Shoba"
              className="img-fluid rounded shadow"
            />
          </div>
          <div className="col-md-6   col-12 taj-bussiness-des  mt-4">
            
            <h2 className="fw-bold">A WORLD OF PRIVILEGES AND BENEFITS</h2>
            <p className="mt-3">
            Unlock a host of elevated experiences and unmatched rewards with the V hotel Pass loyalty program. Enjoy exclusive room rates, earn and redeem V Coins, and indulge in premium benefits across all V Hotel properties in Mahipalpur, Delhi, and beyond. Whether you're staying for leisure or business, our membership enhances every stay with plush comforts, gourmet dining, and seamless services at V Hotel The Grand Shoba.</p>
            <div className="d-flex corpo-bussiness-main gap-5">
              <div className="corpo-business-btn">
                <Link title='v hotel the grand shoba corporate-query' to="/corporate-query"> <button className=" corpo-business-btn  ">QUERY</button></Link></div> 
              
                 <div className="corpo-business-btn">   
                 <Link title='v hotel the grand shoba gallery' to="/gallery">  <button className=" corpo-business-btn ">View Gallery</button> </Link>
              </div>
            </div>
          </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default TajBusinessConnect;
